<template>
    <div class="campaigns-dashboard__empty-message-wrapper">
        <template v-if="userCanAddCampaign">
            <hox-empty-message>
                <template #title>No campaigns exist for this client</template>
                <template #actionItems>
                    <Button
                        v-if="userCanAddCampaign"
                        data-testid="create-campaign__button"
                        type="primary"
                        @click="toggleCreateCampaignModalIsVisible"
                    >
                        Create new campaign
                    </Button>
                </template>
            </hox-empty-message>
        </template>

        <template v-else>
            <hox-empty-message>
                <template #title>You don't have access to any campaigns for this client</template>
                <template #actionItems>
                    <Button v-if="userCanAddCampaign" type="primary" @click="toggleCreateCampaignModalIsVisible">
                        Create new campaign
                    </Button>
                </template>
            </hox-empty-message>
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "NoCampaignsMessage",
    props: {
        userCanAddCampaign: {
            type: Boolean,
            required: true
        }
    },
    emits: ["toggleCreateCampaignModalIsVisible"],
    methods: {
        toggleCreateCampaignModalIsVisible() {
            this.$emit("toggleCreateCampaignModalIsVisible");
        }
    }
});
</script>

<style lang="scss" scoped>
@use "@style/variables" as *;

.campaigns-dashboard__empty-message-wrapper {
    padding: $spacing-large 0 0 0;
}
</style>
